// Константы и конфигурации для активов

export const DEFAULT_CATEGORIES = [
  "Электроника", 
  "Мебель", 
  "Транспорт", 
  "Инструменты", 
  "Спорт",
  "Бытовая техника"
];

export const DEFAULT_DISCOUNTS = ["Нет", "5%", "10%", "15%", "20%", "25%", "30%"];

export const DEFAULT_STATUSES = [
  { id: 1, name: "Доступен", status_key: "available" },
  { id: 2, name: "В аренде", status_key: "rented" },
  { id: 3, name: "На обслуживании", status_key: "maintenance" },
  { id: 4, name: "Недоступен", status_key: "unavailable" }
];

export const TECHNICAL_SPECS_BY_CATEGORY = {
  "Электроника": [
    { key: "brand", label: "Бренд", type: "text" },
    { key: "model", label: "Модель", type: "text" },
    { key: "power", label: "Мощность (Вт)", type: "number" },
    { key: "voltage", label: "Напряжение (В)", type: "number" },
    { key: "warranty", label: "Гарантия (мес)", type: "number" }
  ],
  "Транспорт": [
    { key: "brand", label: "Марка", type: "text" },
    { key: "model", label: "Модель", type: "text" },
    { key: "year", label: "Год выпуска", type: "number" },
    { key: "engine_volume", label: "Объем двигателя", type: "text" },
    { key: "fuel_type", label: "Тип топлива", type: "text" },
    { key: "mileage", label: "Пробег (км)", type: "number" }
  ],
  "Мебель": [
    { key: "material", label: "Материал", type: "text" },
    { key: "dimensions", label: "Размеры", type: "text" },
    { key: "weight", label: "Вес (кг)", type: "number" },
    { key: "color", label: "Цвет", type: "text" },
    { key: "style", label: "Стиль", type: "text" }
  ],
  "Инструменты": [
    { key: "brand", label: "Бренд", type: "text" },
    { key: "type", label: "Тип инструмента", type: "text" },
    { key: "power", label: "Мощность (Вт)", type: "number" },
    { key: "weight", label: "Вес (кг)", type: "number" },
    { key: "voltage", label: "Напряжение (В)", type: "number" }
  ],
  "Спорт": [
    { key: "brand", label: "Бренд", type: "text" },
    { key: "size", label: "Размер", type: "text" },
    { key: "weight", label: "Вес (кг)", type: "number" },
    { key: "material", label: "Материал", type: "text" },
    { key: "sport_type", label: "Вид спорта", type: "text" }
  ],
  "Бытовая техника": [
    { key: "brand", label: "Бренд", type: "text" },
    { key: "model", label: "Модель", type: "text" },
    { key: "power", label: "Мощность (Вт)", type: "number" },
    { key: "energy_class", label: "Класс энергопотребления", type: "text" },
    { key: "capacity", label: "Объем/вместимость", type: "text" }
  ]
};

export const AI_FIELD_PROMPTS = {
  description: "Создай подробное описание для актива категории '{category}' с названием '{name}'. Описание должно быть профессиональным, привлекательным для клиентов и содержать ключевые характеристики.",
  search_keywords: "Сгенерируй список ключевых слов для поиска актива '{name}' категории '{category}'. Включи синонимы, популярные запросы и термины, по которым клиенты могут искать этот актив.",
  search_description: "Создай краткое SEO-описание для актива '{name}' категории '{category}', которое будет отображаться в результатах поиска."
};

export const DEFAULT_ASSET_STATE = {
  name: "",
  sku: "",
  inventory_number: "",
  status: "",
  asset_status_id: null,
  rental_point: "",
  rental_point_id: null,
  category: "",
  description: "",
  images: [],
  deposit: "",
  purchase_price: "",
  purchase_date: "",
  maintenance_due_date: "",  // Дата обслуживания актива
  discount: "",
  parameters: [],
  tariff: "",
  tariff_id: null,
  technical_specifications: {},
  
  // Поисковые метаданные (правильная структура)
  search_metadata: {
    tags: [],
    target_audience: [],
    use_cases: []
  },
  
  // Технические характеристики (теги) - для совместимости
  brands: [],
  models: [],
  tech_params: [],
  materials: [],
  
  // AI поля (теги) - для совместимости
  ai_features: [],
  ai_qualities: [],
  advantages: [],
  usage_conditions: [],
  
  // Дублированные поля для совместимости
  ai_search_keywords: "",
  ai_tags: [],
  target_audience: [],
  use_cases: [],
  
  // Текстовые поля
  ai_description: "",
  ai_keywords: "",
  search_keywords: "",
  search_description: "",
  meta_title: "",
  meta_description: ""
};

export const DEFAULT_ASSET_STATS = {
  total_rentals: 0,
  active_rentals: 0,
  completed_rentals: 0,
  total_revenue: 0
};
